export const LOADER_SHOW = 'ui/loader/show'
export const LOADER_HIDE = 'ui/loader/hide'

export const showLoader = () => ({ type: LOADER_SHOW })

export const hideLoader = () => ({ type: LOADER_HIDE })
